import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  RootComponentListPageContext,
  RootComponentListPageInitialState,
} from ".";

export const RootComponentListPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(RootComponentListPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <RootComponentListPageContext.Provider value={context}>
      {children}
    </RootComponentListPageContext.Provider>
  );
};
